import { PaymentMethodState } from '../../codegen/vehicles';

export const paymentMethodStateTextColors: Record<PaymentMethodState, string> =
  {
    ACTIVE: 'text-color-success',
    ONBOARDING_PENDING: 'text-color-warning',
    ONBOARDING_FAILURE: 'text-color-danger',
  };
